import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import AccountStore from '../../../store/AccountStore';
import { modelOf } from '../../../prop-types';

@observer
export class MyAccountBasicInfo extends Component {
  render() {
    const { myAccountInfo } = this.props;

    const customerIdLabel = myAccountInfo.customerId && (
      <li key="customerId">
        <FormattedMessage
          id="myAccount.customerIdLabel"
          defaultMessage="Customer ID: {customerId}"
          values={{
            customerId: <span>{myAccountInfo.customerId}</span>
          }}
        />
      </li>
    );
    const groupNameLabel = myAccountInfo.group && (
      <li key="groupName">
        <FormattedMessage
          id="myAccount.groupNameLabel"
          defaultMessage="Customer group: {group}"
          values={{
            group: <span>{myAccountInfo.group}</span>
          }}
        />
      </li>
    );
    const nameLabel = myAccountInfo.name && (
      <li key="name">
        <FormattedMessage
          id="myAccount.nameLabel"
          defaultMessage="Name: {name}"
          values={{
            name: <span>{myAccountInfo.name}</span>
          }}
        />
      </li>
    );
    const companyLabel = myAccountInfo.company && (
      <li key="company">
        <FormattedMessage
          id="myAccount.companyLabel"
          defaultMessage="Company: {company}"
          values={{
            company: <span>{myAccountInfo.company}</span>
          }}
        />
      </li>
    );
    const emailLabel = myAccountInfo.email && (
      <li key="email">
        <FormattedMessage
          id="myAccount.emailLabel"
          defaultMessage="Email: {email}"
          values={{
            email: <span>{myAccountInfo.email}</span>
          }}
        />
      </li>
    );
    const telephoneLabel = myAccountInfo.telephone && (
      <li key="telephone">
        <FormattedMessage
          id="myAccount.telephoneLabel"
          defaultMessage="Telephone: {telephone}"
          values={{
            telephone: <span>{myAccountInfo.telephone}</span>
          }}
        />
      </li>
    );

    const myAccountInfoLabels = [
      customerIdLabel,
      groupNameLabel,
      nameLabel,
      companyLabel,
      emailLabel,
      telephoneLabel
    ];
    return (
      <div className="MyAccountBasicInfo">
        <h2>
          <FormattedMessage
            id="myAccount.basicInfo"
            defaultMessage="Account basic info"
          />
        </h2>
        <ul className="MyAccountBasicInfo__list_items">
          {myAccountInfoLabels}
        </ul>
      </div>
    );
  }
}

MyAccountBasicInfo.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  myAccountInfo: PropTypes.shape({
    customerId: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    telephone: PropTypes.string,
    company: PropTypes.string,
    group: PropTypes.string
  })
};

export default inject('accountStore')(MyAccountBasicInfo);
